const config = {
  MainColor: '#AD1C42',
};

export { config };
